"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _fp = require("lodash/fp");
var _definitions = /*#__PURE__*/ _interop_require_default(require("../../../../definitions"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var getDefinitionErrors = function(offer) {
    return (0, _fp.flow)((0, _fp.get)('offerTypes'), (0, _fp.map)(function(offerType) {
        var offerTypeId = (0, _fp.get)('identifier.current', offerType);
        if ((0, _fp.isNil)(offerTypeId)) {
            return {
                message: 'Missing offerType identifier'
            };
        }
        var offerTypeDefinition = _definitions.default[offerTypeId];
        if ((0, _fp.isNil)(offerTypeDefinition)) {
            return {
                message: 'Missing offerType definition',
                offerTypeId: offerTypeId
            };
        }
        // Only proceed if rewards are defined, sometimes we don't make that graphql call
        if ((0, _fp.isUndefined)(offerType.givesAccessToOneOfRewards)) {
            return null;
        }
        var rewardIds = (0, _fp.compact)((0, _fp.map)('identifier.current', offerType.givesAccessToOneOfRewards));
        // Not every offer type needs to have rewards (eg refer a friend (fnd, ref))
        if ((0, _fp.isEmpty)(rewardIds)) {
            return null;
        }
        var definitionRewardIds = (0, _fp.map)('id', offerTypeDefinition.rewards);
        var differenceRewardIds = (0, _fp.xor)(definitionRewardIds, rewardIds);
        if (!(0, _fp.isEmpty)(differenceRewardIds)) {
            return {
                definitionRewardIds: definitionRewardIds,
                differenceRewardIds: differenceRewardIds,
                message: 'Difference rewardIds',
                offerTypeId: offerTypeId,
                rewardIds: rewardIds
            };
        }
        return null;
    }), _fp.compact)(offer);
};
var _default = getDefinitionErrors;
